// src/features/records/components/GalleryView/transitions/runMediaTransition.js
export async function runMediaTransition({ fromId, toEl }) {
  if (!toEl) return;
  const prefersReduced =
    window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  if (prefersReduced) return;

  const canVTA =
    !!document.startViewTransition &&
    'viewTransitionName' in document.documentElement.style;

  if (canVTA) {
    // View Transitions API path
    const vtName = `media-active`;
    const restore = [];

    // Target (lightbox active media wrapper)
    const oldTo = toEl.style.viewTransitionName;
    toEl.style.viewTransitionName = vtName;
    restore.push(() => (toEl.style.viewTransitionName = oldTo ?? ''));

    // Source (thumbnail), if present
    let src = null;
    if (fromId) {
      src = document.querySelector(
        `[data-media-id="${fromId}"] img, [data-media-id="${fromId}"]`
      );
      if (src) {
        const oldSrc = src.style.viewTransitionName;
        src.style.viewTransitionName = vtName;
        restore.push(() => (src.style.viewTransitionName = oldSrc ?? ''));
      }
    }

    try {
      const vt = document.startViewTransition(() => {});
      await vt.finished;
    } finally {
      restore.forEach((fn) => fn());
    }
    return;
  }

  // FLIP fallback
  const dstRect = toEl.getBoundingClientRect();
  let srcRect = null;
  if (fromId) {
    const srcEl = document.querySelector(
      `[data-media-id="${fromId}"] img, [data-media-id="${fromId}"]`
    );
    if (srcEl) srcRect = srcEl.getBoundingClientRect();
  }
  if (!srcRect) return; // graceful no-op; keep CSS fade if any

  const dx = srcRect.left - dstRect.left;
  const dy = srcRect.top - dstRect.top;
  const sx = srcRect.width / Math.max(1, dstRect.width);
  const sy = srcRect.height / Math.max(1, dstRect.height);

  const el = toEl;
  const prev = {
    transform: el.style.transform,
    transition: el.style.transition,
    opacity: el.style.opacity,
    willChange: el.style.willChange,
    origin: el.style.transformOrigin,
  };
  el.style.transformOrigin = 'top left';
  el.style.willChange = 'transform, opacity';
  el.style.transform = `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`;
  el.style.opacity = '0.999';
  // force style flush
  // eslint-disable-next-line no-unused-expressions
  el.offsetWidth;
  el.style.transition =
    'transform 280ms cubic-bezier(0.2,0.7,0.2,1), opacity 160ms ease-out';
  el.style.transform = 'none';
  el.style.opacity = '1';

  await new Promise((resolve) => {
    const onEnd = () => {
      el.removeEventListener('transitionend', onEnd);
      el.style.transform = prev.transform;
      el.style.transition = prev.transition;
      el.style.opacity = prev.opacity;
      el.style.willChange = prev.willChange;
      el.style.transformOrigin = prev.origin;
      resolve();
    };
    el.addEventListener('transitionend', onEnd);
  });
}